var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.308 21.5a1.74 1.74 0 01-1.277-.531 1.74 1.74 0 01-.531-1.277v-9.384c0-.497.177-.923.531-1.277A1.74 1.74 0 016.308 8.5H7.5v-2c0-1.249.438-2.31 1.313-3.187C9.69 2.438 10.752 2 12 2c1.249 0 2.31.438 3.187 1.313.875.876 1.313 1.938 1.313 3.187v2h1.192c.497 0 .923.177 1.277.531.354.354.531.78.531 1.277v9.384c0 .497-.177.923-.531 1.277a1.74 1.74 0 01-1.277.531H6.308zM12 16.75c.486 0 .899-.17 1.24-.51.34-.341.51-.754.51-1.24s-.17-.899-.51-1.24c-.341-.34-.754-.51-1.24-.51s-.899.17-1.24.51c-.34.341-.51.754-.51 1.24s.17.899.51 1.24c.341.34.754.51 1.24.51zM9 8.5h6v-2c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0012 3.5c-.833 0-1.542.292-2.125.875A2.893 2.893 0 009 6.5v2z",
    fill: "currentColor"
  })));
}
SvgLockFilled.displayName = 'LockFilled';
export default SvgLockFilled;